import * as R from 'ramda';
import { Endpoints } from '../../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../../core/api/module';
import { ActionType } from '../../../../core/redux/actionType';


const KEY_ACTION = ActionType.SendDevPlanRequest;
const ACTIONS    = [
  ActionType.SendDevPlanRequest,
  ActionType.SendDevPlanResponse,
  ActionType.SendDevPlanError,
];


type Payload = undefined;
type Meta = { to: string; };


/**
 * Dispatch this action to email the user's dev plan to the given recipient.
 */
export const sendDevPlanAction = (
  projectId: number,
  participantId: number,
  to: string,
  comment: string | undefined,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.SendDevPlan,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({
    projectId,
    participantId,
    to: [{ toAddress: to, languageId: state.locale.lang.languageId }],
    comment,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { to }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(
    ['devPlan', 'lastEmailRecipient'],
    action.meta.to,
    R.assocPath(
      ['projectSummary', 'devPlanEmailSent'],
      true,
      successState,
    ),
  );
};


export const sendDevPlanReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
